/* istanbul ignore file */
//! PLEASE keep this list in alphabetical order for a better readability
export enum EMAIL_DOMAINS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=614303682
     */
    ADD_DOMAIN = 'EMAIL_DOMAINS.ADD_DOMAIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=504721664
     */
    ADD_SITE = 'MOBILE.ADD_SITE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633803305
     */
    ALIAS = 'EMAIL_DOMAINS.ALIAS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=626934879
     */
    CHECK_CONFIGURATION = 'EMAIL_DOMIANS.CHECK_CONFIGURATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618855939
     */
    CONFIRM_CREATION_DESCRIPTION = 'EMAIL_DOMAINS.CONFIRM_CREATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618839434
     */
    CONFIRM_CREATION_TITLE = 'EMAIL_DOMAINS.CONFIRM_CREATION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=634032031
     */
    CONFIRM_PLATFORM_DESCRIPTION_1 = 'EMAIL_DOMAINS.CONFIRM_PLATFORM_DESCRIPTION_1',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633876661
     */
    CONFIRM_PLATFORM_DESCRIPTION_2 = 'EMAIL_DOMAINS.CONFIRM_PLATFORM_DESCRIPTION_2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=640470302
     */
    CONFIRM_REMOVE_DEFAULT = 'EMAIL_DOMAINS.CONFIRM_REMOVE_DEFAULT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=640470462
     */
    CONFIRM_REMOVE_NOT_DEFAULT = 'EMAIL_DOMAINS.CONFIRM_REMOVE_NOT_DEFAULT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618890997
     */
    CREATION_DESCRIPTION = 'EMAIL_DOMAINS.CREATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618891113
     */
    CREATION_HELPER = 'EMAIL_DOMAINS.CREATION_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=635092585
     */
    CUSTOMIZE_SITE_HELPER = 'EMAIL_DOMAINS.CUSTOMIZE_SITE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=621680910
     */
    DNS_CONFIGURATION = 'EMAIL_DOMAINS.DNS_CONFIGURATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623349859
     */
    DNS_CONFIGURATION_DESCRIPTION = 'EMAIL_DOMAINS.DNS_CONFIGURATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618839713
     */
    DOMAIN_CREATED = 'EMAIL_DOMAINS.DOMAIN_CREATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618839571
     */
    DOMAIN_NAME = 'EMAIL_DOMAINS.DOMAIN_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=626975748
     */
    DNS_NOT_READY = 'EMAIL_DOMAINS.DNS_NOT_READY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=626975541
     */
    DNS_VALIDATED = 'EMAIL_DOMAINS.DNS_VALIDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=318880072
     */
    DOMAINS_MANAGEMENT = 'DOMAINS_MANAGEMENT.TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=621693634
     */
    DOMAIN_TEST = 'EMAIL_DOMAINS.DOMAIN_TEST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=629247388
     */
    DOMAIN_TEST_MESSAGE = 'EMAIL_DOMAINS.DOMAIN_TEST_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=629247904
     */
    DOMAIN_TEST_CONFIRM_MESSAGE = 'EMAIL_DOMAINS.DOMAIN_TEST_CONFIRM_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=614296724
     */
    EMAIL_DOMAINS = 'EMAIL_DOMAINS.EMAIL_DOMAINS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633803385
     */
    EMAIL_PREFIX = 'EMAIL_DOMAINS.EMAIL_PREFIX',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=653600089
     */
    ERROR_CONFLICT_WITH_VANITY_URL = 'EMAIL_DOMAINS.ERROR_CONFLICT_WITH_VANITY_URL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619095619
     */
    ERROR_DOMAIN_ALREADY_CONFIGURED = 'EMAIL_DOMAINS.ERROR_DOMAIN_ALREADY_CONFIGURED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619095529
     */
    ERROR_DOMAIN_ALREADY_EXISTS = 'EMAIL_DOMAINS.ERROR_DOMAIN_ALREADY_EXISTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=232450638
     */
    ERROR_DOMAIN_NAME_INVALID = 'MOBILE.CONFIGURATION_INVALID_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=614373132
     */
    EMPTY_STATE_MESSAGE = 'EMAIL_DOMAINS.EMPTY_STATE_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=614341269
     */
    EMPTY_STATE_TITLE = 'EMAIL_DOMAINS.EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623511471
     */
    INBOUND_EMAILS = 'EMAIL_DOMAINS.INBOUND_EMAILS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623520977
     */
    INBOUND_EMAILS_DESCRIPTION = 'EMAIL_DOMAINS.INBOUND_EMAILS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=614460643
     */
    INFO_MESSAGE = 'EMAIL_DOMAINS.INFO_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619327668
     */
    NAME_HELPER_RULE_1 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_1',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619327693
     */
    NAME_HELPER_RULE_2 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619328987
     */
    NAME_HELPER_RULE_3 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_3',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=631239214
     */
    NO_ASSIGNMENT = 'EMAIL_DOMAINS.NO_ASSIGNMENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633781064
     */
    PLATFORM_ASSIGNMENT_CONFIRMED = 'EMAIL_DOMAINS.PLATFORM_ASSIGNMENT_CONFIRMED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623505696
     */
    RECEIVING_RECORDS = 'EMAIL_DOMAINS.RECEIVING_RECORDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623507178
     */
    RECEIVING_RECORDS_DESCRIPTION = 'EMAIL_DOMAINS.RECEIVING_RECORDS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327119270
     */
    RECORD_NAME = 'DOMAINS_MANAGEMENT.RECORD_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327119297
     */
    RECORD_VALUE = 'DOMAINS_MANAGEMENT.RECORD_VALUE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=637443412
     */
    REMOVE_SITE_MESSAGE = 'EMAIL_DOMAINS.REMOVE_SITE_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=629241497
     */
    RETRY_TEST = 'EMAIL_DOMAINS.RETRY_TEST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633069513
     */
    SEND_ME_A_TEST = 'EMAIL_DOMAINS.SEND_ME_A_TEST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623408483
     */
    SENDING_RECORDS = 'EMAIL_DOMAINS.SENDING_RECORDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=631239746
     */
    SET_AS_PLATFORM_DEFAULT = 'EMAIL_DOMAINS.SET_AS_PLATFORM_DEFAULT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=633876937
     */
    SET_AS_PLATFORM_DEFAULT_QUESTION = 'EMAIL_DOMAINS.SET_AS_PLATFORM_DEFAULT_QUESTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=635091916
     */
    SITE_ADDED = 'EMAIL_DOMAINS.SITE_ADDED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=637565131
     */
    SITE_REMOVED = 'EMAIL_DOMAINS.SITE_REMOVED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623505417
     */
    TRACKING_RECORDS = 'EMAIL_DOMAINS.TRACKING_RECORDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623505464
     */
    TRACKING_RECORDS_DESCRIPTION = 'EMAIL_DOMAINS.TRACKING_RECORDS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=621695128
     */
    USE_DOMAIN = 'EMAIL_DOMAINS.USE_DOMAIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=631238947
     */
    USE_DOMAIN_PLATFORM_HELPER = 'EMAIL_DOMAINS.USE_DOMAIN_PLATFORM_HELPER',
}
